import React from 'react';
import InlineForm from '@plone/volto/components/manage/Form/InlineForm';
import { Icon, SidebarPortal } from '@plone/volto/components';
import buttonSVG from '@plone/volto/icons/image-wide.svg';
import CountdownSchema from './schema';
import View from './View';

const Edit = (props) => {
  const schema = CountdownSchema(props.intl);
  return (
    <>
      <SidebarPortal selected={props.selected}>
        <InlineForm
          schema={schema}
          title={schema.title}
          icon={<Icon name={buttonSVG} />}
          onChangeField={(id, value) => {
            props.onChangeBlock(props.block, {
              ...props.data,
              [id]: value,
            });
          }}
          formData={props.data}
        />
      </SidebarPortal>
      <View data={props.data} metadata={props.metadata} isEditMode={true} />
    </>
  );
};

export default Edit;
